module.exports = __webpack_public_path__ + "static/media/modul_buzzer.c158518e.png";